import { render, staticRenderFns } from "./UpdateTemplateIsoPermissions.vue?vue&type=template&id=3798e6fa&scoped=true&"
import script from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js&"
export * from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTemplateIsoPermissions.vue?vue&type=style&index=0&id=3798e6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798e6fa",
  null
  
)

export default component.exports